module.exports = __webpack_public_path__ + "static/CONSCIOUS-LIVING-8aa23bdf8783e1d5197eb334ff9d0fb2.png";